// export const GMT = "GTM-K94ZV7G";
export const MEASUREMENT_ID = "G-PCTYTW17XT";

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyAQUCGV0EiG8PfxwvQjlGLXPLs5axFZj7c",
  authDomain: "dzenis-tech-e7c07.firebaseapp.com",
  projectId: "dzenis-tech-e7c07",
  storageBucket: "dzenis-tech-e7c07.appspot.com",
  messagingSenderId: "420404750693",
  appId: "1:420404750693:web:b10044b6e0bec9dcbc598c",
};
